module.exports = __webpack_public_path__ + "img/d201106-2.f0453317.jpg";